import { RegularSection, ColorTitle } from '@/components/Layouts'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import Chip from '@mui/material/Chip'
import Link from 'next/link'
import { resolveHref } from '@/utilites/resolveHref'
import { getImageData } from '@/utilites/getImageData'
import LocationPinIcon from '@mui/icons-material/LocationPin'
import locationsData from '@/content/locations.json'

interface ImageData {
    src?: string
    alt?: string
}

interface GridItem {
    title?: string
    subtitle?: string
    image?: ImageData
}

interface LocationItem {
    href: string
    area: string
    city: string
}

interface Content {
    title?: string
    grid1?: GridItem
    grid2?: GridItem
}

interface ServiceAreaProps {
    content?: Content
    blockName?:string
}

const Index = (props: ServiceAreaProps) => {
    const { content = {} } = props
    const { title, grid1 = {}, grid2 = {} } = content
    const grid1Image = getImageData((grid1 as GridItem)?.image)
    const grid2Image = getImageData((grid2 as GridItem)?.image)
    return (
        <RegularSection aria-label='ServiceArea' >
            <Grid
                container
                spacing={6}
                sx={{ width: { xs: '95vw', md: '85vw', lg: '70vw' } }}
            >
                {/* Left: Form */}
                <Grid size={12}>
                    <ColorTitle
                        title={title}
                        variant='h1'
                        colorFrom={0}
                        colorTo={1}
                        textAlign='center'
                        color='black'
                        width='100%'
                    />
                </Grid>
                {/* Right: Image */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Image
                        src={grid1Image.src || '/img/Wire_Cutting__Bank_Vault_Demolition.jpg'}
                        alt={grid1Image.alt || 'Wire Cutting, Bank Vault Demolition  Service Area Map'}
                        width={670}
                        height={360}
                        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography variant='h2'> {grid1?.title} </Typography>
                    <Typography variant='body1'> {grid1?.subtitle} </Typography>
                </Grid>

                <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center' }}
                >
                    <Typography variant='h2'> {grid2?.title} </Typography>
                    <Typography variant='body1'> {grid2?.subtitle} </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Image
                        src={ grid2Image.src ||
                            '/img/Wire_Cutting__Bank_Vault_Demolition__Wall_Sawing__Floor_Sawing__Core_Drilling__GPR_Scanning__Trenching.jpg'
                        }
                        alt={ grid2Image.alt || 'Wire Cutting & Bank Vault Demolition'}
                        width={670}
                        height={360}
                        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                    />
                </Grid>
                <Grid size={12} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    {locationsData
                        .filter((item: LocationItem) => item.href && item.href.trim() !== '')
                        .map((item: LocationItem, index: number) => (
                            <Link
                                key={'municipalities-' + index}
                                href={resolveHref(item.href)}
                                style={{ textDecoration: 'none' }}
                                target='_blank'
                            >
                                <Chip
                                    icon={<LocationPinIcon color='primary' />}
                                    label={`${item.city}${item.area ? `, ${item.area}` : ''}`}
                                    sx={{ m: 0.5 }}
                                />
                            </Link>
                        ))}
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
